import ApiClient from '../ApiClient';
import axios from 'axios';
import Auth from '../../api/auth';

class ZaloPersonalAPI extends ApiClient {
  constructor() {
    super('channels/zalo_personal_channel', { accountScoped: true });
  }

  create(data) {
    const headers = {};
    if (Auth.hasAuthCookie()) {
      const {
        'access-token': accessToken,
        'token-type': tokenType,
        client,
        expiry,
        uid,
      } = Auth.getAuthData();
      Object.assign(headers, {
        'access-token': accessToken,
        'token-type': tokenType,
        client,
        expiry,
        uid,
      });
    }
    return axios.post(this.url, data, { headers });
  }

  reauthorize(params) {
    const headers = {};
    if (Auth.hasAuthCookie()) {
      const {
        'access-token': accessToken,
        'token-type': tokenType,
        client,
        expiry,
        uid,
      } = Auth.getAuthData();
      Object.assign(headers, {
        'access-token': accessToken,
        'token-type': tokenType,
        client,
        expiry,
        uid,
      });
    }
    return axios.post(`${this.url}/${params.id}/reauthorize`, params, { headers });
  }
}

export default new ZaloPersonalAPI();